export const formatDate = (date, options)=>new Date(date).toLocaleDateString('de-DE', {
        timeZone: 'Europe/Berlin',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        ...options
    });

//# sourceMappingURL=date.js.map